function initSwiper() {
  if (typeof Swiper !== 'undefined') {
    const bundleProductsSwiper = new Swiper('.bundle_products_swiper', {
      slidesPerView: 1.05,
      breakpoints: {
        500: {
          slidesPerView: 1.3,
        },
        650: {
          slidesPerView: 1.6,
        },
        720: {
          slidesPerView: 2,
        },
        959: {
          slidesPerView: 1.1,
        },
      },
      spaceBetween: 12,
      navigation: {
        nextEl: '.bundle-swiper-button-next',
        prevEl: '.bundle-swiper-button-prev',
      },
      on: {
        slideChange: function () {
          document.querySelectorAll('.product-bundle-item').forEach(item => {
            item.classList.remove('active');
            const toggle = item.querySelector('.bundle-item__toggle-icon');
            if (toggle) toggle.setAttribute('aria-expanded', 'false');
          });
        }
      }
    });
  } else {
    setTimeout(initSwiper, 100);
  }
}

function initBundleToggles() {
  const toggleButtons = document.querySelectorAll('.bundle-item__toggle-icon');

  toggleButtons.forEach(button => {
    // Initialise aria-expanded based on current active class.
    const initialItem = button.closest('.product-bundle-item');
    if (initialItem) {
      button.setAttribute(
        'aria-expanded',
        initialItem.classList.contains('active') ? 'true' : 'false'
      );
    }

    button.addEventListener('click', function (e) {
      e.preventDefault();
      const bundleItem = this.closest('.product-bundle-item');
      if (!bundleItem) return;
      const isActive = bundleItem.classList.contains('active');

      document.querySelectorAll('.product-bundle-item').forEach(item => {
        if (item !== bundleItem) {
          item.classList.remove('active');
          const otherToggle = item.querySelector('.bundle-item__toggle-icon');
          if (otherToggle) otherToggle.setAttribute('aria-expanded', 'false');
        }
      });

      if (isActive) {
        bundleItem.classList.remove('active');
        this.setAttribute('aria-expanded', 'false');
      } else {
        bundleItem.classList.add('active');
        this.setAttribute('aria-expanded', 'true');
      }
    });
  });
}

initSwiper();
initBundleToggles();

setTimeout(function() {
  const bundleSection = document.querySelector('.bundle-products-section');
  const descriptionAccordion = document.querySelector('.description-accordion');

  if (!bundleSection || !descriptionAccordion) {
    console.log('Elements not found');
    return;
  }

  const originalParent = bundleSection.parentNode;
  const originalNextSibling = bundleSection.nextSibling;
  let isMoved = false;

  function repositionBundle() {
    const isMobile = window.innerWidth < 959;

    if (isMobile && !isMoved) {
      descriptionAccordion.parentNode.insertBefore(bundleSection, descriptionAccordion);
      isMoved = true;
    } else if (!isMobile && isMoved) {
      if (originalNextSibling && originalNextSibling.parentNode) {
        originalParent.insertBefore(bundleSection, originalNextSibling);
      } else {
        originalParent.appendChild(bundleSection);
      }
      isMoved = false;
    }
  }

  repositionBundle();

  window.addEventListener('resize', function() {
    repositionBundle();
  });
}, 500);
